import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ProfileSelectorConfigDto } from '../dto/profile-selector-config.dto';
import { ProfileSelectorSelectedFieldDto } from '../dto/profile-selector-selected-field.dto';
import { SelectItem, MenuItem } from 'primeng/api';
import { ProfileSelectorFieldEnum } from '../dto/profile-selector-field.enum';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { FieldTypeEnum } from 'src/app/shared/search-expression/field-type.enum';
import { ProfileSelectorFieldTypeEnum } from '../dto/profile-selector-field-type.enum';
import { CustomFieldService } from '../../shared/custom-field.service';
import { AuthService, NotificationService, PagedSearch, TranslationService } from 'src/app/shared';
import { AffCodeTypeService } from 'src/app/affcode/shared/aff-code-type.service';
import { AffCodeTypeSearchDto } from 'src/app/affcode/shared/dto/aff-code-type-search.dto';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { AffiliationSearchDto } from 'src/app/affcode/shared/dto/affiliation-search.dto';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'wl-profile-search-manage-columns',
  templateUrl: './profile-search-manage-columns.component.html',
  styleUrls: ['./profile-search-manage-columns.component.less'],
  standalone: false,
})
export class ProfileSearchManageColumnsComponent implements OnInit {
  @Input() settings: ProfileSelectorConfigDto;
  @Output() settingsSaved = new EventEmitter<boolean>();
  @Output() settingsCleared = new EventEmitter<boolean>();
  show = false;
  selectedFieldMap: Array<SelectItem>;
  availableFields: Array<SelectItem>;
  fieldEnum = ProfileSelectorFieldEnum;
  selectorTypeEnum = ProfileSelectorFieldTypeEnum;
  customFields: Array<SelectItem>;
  affCodeTypes: Array<SelectItem>;
  affCodes: Array<SelectItem>;
  rowMenuItems: MenuItem[];

  constructor(
    private _configServiceService: ConfigServiceService,
    private _customFieldService: CustomFieldService,
    private _affCodeTypeService: AffCodeTypeService,
    private _affCodeService: AffCodeService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this._configServiceService.getFriendlyFieldNames().then((data) => {
      this.selectedFieldMap = data.map((x) => {
        return { value: x.Key, label: x.Value } as SelectItem;
      });
      this.availableFields = this.selectedFieldMap.filter((x) => x.value != ProfileSelectorFieldEnum.ProfileName);
    });

    this._customFieldService.searchCustomFields({ PageNumber: 0, PageSize: 0 } as PagedSearch).then((data) => {
      this.customFields = data.Result.map((x) => {
        return { value: x.CustomFieldID, label: x.Name } as SelectItem;
      });
    });

    this._affCodeTypeService.search({ PageNumber: 0, PageSize: 0 } as AffCodeTypeSearchDto).then((data) => {
      this.affCodeTypes = data.Result.map((x) => {
        return { value: x.AffCodeTypeID, label: x.AffCodeType } as SelectItem;
      });
    });

    this._affCodeService.search({ PageNumber: 0, PageSize: 0 } as AffiliationSearchDto).then((data) => {
      this.affCodes = data.Result.map((x) => {
        return { value: x.AffId, label: x.AffCode } as SelectItem;
      });
    });
    this.actionItemsForAffCodes();
  }

  actionItemsForAffCodes(): MenuItem[] {
    this.rowMenuItems = [
      {
        label: '+ Add Affiliation Type',
        command: () => this.addAffiliationTypeField(),
      },
      {
        label: '+ Add Affiliation Code',
        command: () => this.addAffiliationCodeField(),
      },
    ];

    return this.rowMenuItems;
  }
  addSystemField() {
    this.settings.SelectedFields.push({ FieldTypeEnum: ProfileSelectorFieldTypeEnum.StandardField } as ProfileSelectorSelectedFieldDto);
  }

  addCustomField() {
    this.settings.SelectedFields.push({ FieldTypeEnum: ProfileSelectorFieldTypeEnum.CustomField } as ProfileSelectorSelectedFieldDto);
  }

  addAffiliationTypeField() {
    this.settings.SelectedFields.push({ FieldTypeEnum: ProfileSelectorFieldTypeEnum.AffCodeType } as ProfileSelectorSelectedFieldDto);
  }

  addAffiliationCodeField() {
    this.settings.SelectedFields.push({ FieldTypeEnum: ProfileSelectorFieldTypeEnum.AffCode } as ProfileSelectorSelectedFieldDto);
  }

  removeColumn(index) {
    this.settings.SelectedFields.splice(index, 1);
  }

  showDialog() {
    this.show = true;
  }

  save() {
    this._configServiceService
      .upsertProfileSearchConfig(this.settings)
      .then(() => {
        this.show = false;
        this.settingsSaved.emit(true);
        this._notificationService.translateSuccess('profiles.search.manage-columns.settings-saved-success');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  sorted(event) {
    moveItemInArray(this.settings.SelectedFields, event.previousIndex, event.currentIndex);
  }

  clearColumns() {
    this.show = false;
    this.settingsCleared.emit();
  }
}
